import { render, staticRenderFns } from "./MenyRadio.vue?vue&type=template&id=09e647f8&scoped=true&"
import script from "./MenyRadio.vue?vue&type=script&lang=js&"
export * from "./MenyRadio.vue?vue&type=script&lang=js&"
import style0 from "./MenyRadio.vue?vue&type=style&index=0&id=09e647f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e647f8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/atlassian/pipelines/agent/build/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VRadio,VRadioGroup})
